import { isPromise } from '@/lib/isPromise';
import { ref } from 'vue';

export const useSimpleLoad = () => {
  const loading = ref(false);

  function load<T extends (...args: any[]) => any>(cb: T): (...args: Parameters<T>) => ReturnType<T> extends Promise<infer V> ? Promise<V> : ReturnType<T> {
    return (...args: Parameters<T>) => {
      loading.value = true;

      const result = cb(...args);

      if (isPromise(result)) {
        return result.then((value) => {
          loading.value = false;
          return value;
        });
      }
      else {
        loading.value = false;
        return result;
      }
    };
  }

  return { loading, load };
};
